/**
 * Current ID token for API requests. Set by AuthContext; read by api/refresh and other authenticated fetches.
 * onUnauthorized is called when the backend returns 401 (e.g. token expired).
 */
let currentToken: string | null = null;
let onUnauthorizedCallback: () => void = () => {};

export function getAuthToken(): string | null {
  return currentToken;
}

export function setAuthToken(token: string | null): void {
  currentToken = token;
}

export function setOnUnauthorized(callback: () => void): void {
  onUnauthorizedCallback = callback;
}

export function triggerUnauthorized(): void {
  currentToken = null;
  onUnauthorizedCallback();
}

export function getAuthHeaders(): Record<string, string> {
  const t = getAuthToken();
  if (!t) return {};
  return { Authorization: `Bearer ${t}` };
}
